import * as R from 'ramda';
import { PortalType } from '../../navigation/portalType';


type UserPermissions = {
  hasPortalLoginPermission: boolean;
  hasRaterApprovalLoginPermission: boolean;
  hasReportRecipientLoginPermission: boolean;
}


/**
 *  Users can access three different portal namespaces based on their permissions. This method returns the permission
 *  setting that should be checked for the namespace the user is trying to enter.
 *
 *  @param pathname - the sub-path of the base app URL where this check is being run (usually formatted as `/login` or
 *  `/<userType>/login`)
 *  @param user - the user permissions we're checking
 */
export const loginPermission = R.memoizeWith(
  (
    pathname: string,
    user: UserPermissions,
  ) => `${pathname}`
       + `${user.hasRaterApprovalLoginPermission}`
       + `${user.hasReportRecipientLoginPermission}`
       + `${user.hasPortalLoginPermission}`,
  (
    pathname: string,
    user: {
      hasPortalLoginPermission: boolean;
      hasRaterApprovalLoginPermission: boolean;
      hasReportRecipientLoginPermission: boolean;
    },
  ) => pathname.toLowerCase().indexOf(PortalType.RATER_APPROVAL.toLowerCase()) > -1 
    ? user.hasRaterApprovalLoginPermission
    : pathname.toLowerCase().indexOf(PortalType.REPORT_RECIPIENT.toLowerCase()) > -1
      ? user.hasReportRecipientLoginPermission
      : user.hasPortalLoginPermission,
);
